// extracted by mini-css-extract-plugin
var _1 = "bpl__layout-main__HNPNm";
var _2 = "bpl__layout-main__content__xZxyo";
var _3 = "bpl__layout-main__footer__SFg3N";
var _4 = "bpl__layout-main__header__aORnb";
export { _1 as "layout-main", _2 as "layout-main__content", _3 as "layout-main__footer", _4 as "layout-main__header" }
